// import { AiOutlineMenu } from 'react-icons/ai';
import Navbar from './Navbar';
import { motion, AnimatePresence, useCycle } from 'framer-motion';
import { MenuToggle } from './Toggle';
import { MobileNavbar } from './MobileNavbar';

const Header = () => {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const sidebar = {
    open: (height = 1000) => ({
      clipPath: `circle(${height * 2 + 200}px at 90% 46px)`,
      transition: {
        type: 'spring',
        stiffness: 20,
        restDelta: 2,
      },
    }),
    closed: {
      clipPath: 'circle(30px at 90% 46px )',
      transition: {
        delay: 0.5,
        type: 'spring',
        stiffness: 400,
        damping: 40,
      },
    },
  };
  return (
    <>
      <div className=' flex justify-between items-center  pt-4 lg:pt-8 -mx-4 px-4 md:-mx-20 md:px-20 lg:-mx-0 lg:px-0'>
        {/* Logo */}
        <div>
          <img
            src='https://res.cloudinary.com/belong/image/upload/v1650621217/uploaded_resources/logo_gqty7l.png'
            alt='logo'
            className='hidden lg:block w-48'
          />
          <img
            src='https://res.cloudinary.com/belong/image/upload/v1643351815/uploaded_resources/logo-small_mtbkf0.png'
            alt='Logo'
            className='lg:hidden w-16'
          />
        </div>
        {/* Navbar and Mobile Navbar */}
        <div>
          <div className='hidden lg:inline-flex'>
            <Navbar />
          </div>

          <AnimatePresence>
            <motion.nav
              initial={false}
              animate={isOpen ? 'open' : 'closed'}
              custom='100%'
              className='absolute top-0 right-0 lg:hidden w-full'
            >
              <motion.div
                className='absolute top-0 right-0  bg-primary/80  z-10 w-full h-full '
                variants={sidebar}
              >
                <MenuToggle toggle={() => toggleOpen()} />
              </motion.div>
              <MobileNavbar isOpen={isOpen} />
            </motion.nav>
          </AnimatePresence>
        </div>
        {/* register button */}
        {/* <div className='hidden lg:inline-flex'>
          <a
            href='/register'
            className='border border-primary text-primary font-semibold px-6 py-2 hover:bg-primary hover:text-white'
          >
            Register Now
          </a>
        </div> */}
      </div>
    </>
  );
};

export default Header;
